/* tslint:disable */
/* eslint-disable */
/**
 * Datixo API
 * API endpoints for communication with Datixo.
 *
 * The version of the OpenAPI document: v1.0.0
 * Contact: api@datixo.com
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { MoneyOutput } from './MoneyOutput';
import {
    MoneyOutputFromJSON,
    MoneyOutputFromJSONTyped,
    MoneyOutputToJSON,
    MoneyOutputToJSONTyped,
} from './MoneyOutput';

/**
 * 
 * @export
 * @interface AdvertisingDomainOverviewRowData
 */
export interface AdvertisingDomainOverviewRowData {
    /**
     * 
     * @type {string}
     * @memberof AdvertisingDomainOverviewRowData
     */
    domainId?: string | null;
    /**
     * 
     * @type {string}
     * @memberof AdvertisingDomainOverviewRowData
     */
    domain?: string | null;
    /**
     * 
     * @type {number}
     * @memberof AdvertisingDomainOverviewRowData
     */
    campaignCount?: number;
    /**
     * 
     * @type {number}
     * @memberof AdvertisingDomainOverviewRowData
     */
    adCount?: number;
    /**
     * 
     * @type {MoneyOutput}
     * @memberof AdvertisingDomainOverviewRowData
     */
    spend?: MoneyOutput;
    /**
     * 
     * @type {number}
     * @memberof AdvertisingDomainOverviewRowData
     */
    spendShare?: number | null;
    /**
     * 
     * @type {number}
     * @memberof AdvertisingDomainOverviewRowData
     */
    clicks?: number;
    /**
     * 
     * @type {number}
     * @memberof AdvertisingDomainOverviewRowData
     */
    impressions?: number;
    /**
     * 
     * @type {number}
     * @memberof AdvertisingDomainOverviewRowData
     */
    ctr?: number | null;
    /**
     * 
     * @type {MoneyOutput}
     * @memberof AdvertisingDomainOverviewRowData
     */
    cpc?: MoneyOutput | null;
    /**
     * 
     * @type {MoneyOutput}
     * @memberof AdvertisingDomainOverviewRowData
     */
    cpm?: MoneyOutput | null;
    /**
     * 
     * @type {AdvertisingDomainOverviewRowDataFinanceScopeEnum}
     * @memberof AdvertisingDomainOverviewRowData
     */
    financeScope?: AdvertisingDomainOverviewRowDataFinanceScopeEnum;
}


/**
 * @export
 */
export const AdvertisingDomainOverviewRowDataFinanceScopeEnum = {
    RawProvider: 'raw_provider'
} as const;
export type AdvertisingDomainOverviewRowDataFinanceScopeEnum = typeof AdvertisingDomainOverviewRowDataFinanceScopeEnum[keyof typeof AdvertisingDomainOverviewRowDataFinanceScopeEnum];


/**
 * Check if a given object implements the AdvertisingDomainOverviewRowData interface.
 */
export function instanceOfAdvertisingDomainOverviewRowData(value: object): value is AdvertisingDomainOverviewRowData {
    return true;
}

export function AdvertisingDomainOverviewRowDataFromJSON(json: any): AdvertisingDomainOverviewRowData {
    return AdvertisingDomainOverviewRowDataFromJSONTyped(json, false);
}

export function AdvertisingDomainOverviewRowDataFromJSONTyped(json: any, ignoreDiscriminator: boolean): AdvertisingDomainOverviewRowData {
    if (json == null) {
        return json;
    }
    return {
        
        'domainId': json['domainId'] === undefined ? undefined : json['domainId'] === null ? null : json['domainId'],
        'domain': json['domain'] === undefined ? undefined : json['domain'] === null ? null : json['domain'],
        'campaignCount': json['campaignCount'] == null ? undefined : json['campaignCount'],
        'adCount': json['adCount'] == null ? undefined : json['adCount'],
        'spend': json['spend'] == null ? undefined : MoneyOutputFromJSON(json['spend']),
        'spendShare': json['spendShare'] === undefined ? undefined : json['spendShare'] === null ? null : json['spendShare'],
        'clicks': json['clicks'] == null ? undefined : json['clicks'],
        'impressions': json['impressions'] == null ? undefined : json['impressions'],
        'ctr': json['ctr'] === undefined ? undefined : json['ctr'] === null ? null : json['ctr'],
        'cpc': json['cpc'] === undefined ? undefined : json['cpc'] === null ? null : MoneyOutputFromJSON(json['cpc']),
        'cpm': json['cpm'] === undefined ? undefined : json['cpm'] === null ? null : MoneyOutputFromJSON(json['cpm']),
        'financeScope': json['financeScope'] == null ? undefined : json['financeScope'],
    };
}

export function AdvertisingDomainOverviewRowDataToJSON(json: any): AdvertisingDomainOverviewRowData {
    return AdvertisingDomainOverviewRowDataToJSONTyped(json, false);
}

export function AdvertisingDomainOverviewRowDataToJSONTyped(value?: AdvertisingDomainOverviewRowData | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'domainId': value['domainId'],
        'domain': value['domain'],
        'campaignCount': value['campaignCount'],
        'adCount': value['adCount'],
        'spend': MoneyOutputToJSON(value['spend']),
        'spendShare': value['spendShare'],
        'clicks': value['clicks'],
        'impressions': value['impressions'],
        'ctr': value['ctr'],
        'cpc': MoneyOutputToJSON(value['cpc']),
        'cpm': MoneyOutputToJSON(value['cpm']),
        'financeScope': value['financeScope'],
    };
}

